export const CA_HD_2027_REPORT_PATH = "/utility/ca-statewide";
export const CA_TRANSIT_REPORT_PATH = "/utility/ca-transit";

export const PUBLISHED_REPORT_PATHS = [CA_HD_2027_REPORT_PATH];

export const isPublishedReportPath = (pathname = "") =>
  PUBLISHED_REPORT_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
